var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { styled, css } from '@creditas-ui/system';
import { Box } from '@creditas-ui/layout';
import { variant } from '@creditas-ui/utilities';
import { shapeIconsWrapperProps } from './constants';
var base = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n"])));
export var IconContainer = styled('div')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  position: relative;\n"])));

var variantStyles = _ref => {
  var {
    theme: {
      icons
    }
  } = _ref;
  return variant({
    prop: 'variant',
    variants: {
      success: {
        fill: icons('shapeIcons.shape.color.success')
      },
      error: {
        fill: icons('shapeIcons.shape.color.error')
      }
    }
  });
};

var sizes = variant({
  prop: 'size',
  variants: shapeIconsWrapperProps
});
export var ShapeContainer = styled('div')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  position: absolute;\n\n  svg {\n    padding: 4%;\n    .organic-shape {\n      ", "\n    }\n  }\n"])), variantStyles);
export var ShapeIconsElement = styled(Box.withComponent('i', process.env.NODE_ENV === "production" ? {
  target: "ehg0yv30"
} : {
  target: "ehg0yv30",
  label: "ShapeIconsElement"
}))(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), base, sizes);
//# sourceMappingURL=ShapeIcons.style.js.map